var __TEMP__ = require('./_baseExtremum.js');var baseExtremum = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseGt.js');var baseGt = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./identity.js');var identity = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseGt)
    : undefined;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = max;
